module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.1f0cb00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mosca_blanca_pepino/curativa/malphos_1000ce.png
// module id = 2117
// module chunks = 3